export enum FundRaiserStatus {
  Draft = "Draft",
  Active = "Active",
  Inactive = "Inactive",
  Completed = "Completed",
}
